(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaDialogController', SSAreaDialogController);

    SSAreaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSArea'];

    function SSAreaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSArea) {
        var vm = this;

        vm.sSArea = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSArea.id !== null) {
                SSArea.update(vm.sSArea, onSaveSuccess, onSaveError);
            } else {
                SSArea.save(vm.sSArea, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAreaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
